@if (unreadCount() > 0) {
  <p-overlaybadge [value]="unreadCount().toString()" severity="danger">
    <p-button icon="pi pi-bell" [text]="true" [rounded]="true" [ariaLabel]="'shared.notifications.ariaLabel' | translate" (onClick)="togglePanel($event)" />
  </p-overlaybadge>
} @else {
  <p-button icon="pi pi-bell" [text]="true" [rounded]="true" [ariaLabel]="'shared.notifications.ariaLabel' | translate" (onClick)="togglePanel($event)" />
}

<p-popover #panel [style]="{ width: '24rem' }">
  <div class="flex flex-col">
    <div class="flex items-center justify-between border-b border-gray-200 px-3 py-2 dark:border-gray-700">
      <span class="font-semibold">{{ 'shared.notifications.title' | translate }}</span>
      @if (unreadCount() > 0) {
        <button type="button" class="text-sm text-blue-600 hover:underline" (click)="markAllRead()">{{ 'shared.notifications.markAllRead' | translate }}</button>
      }
    </div>

    <div class="max-h-96 overflow-y-auto">
      @for (notification of notifications(); track notification.notificationId) {
        <div
          class="cursor-pointer border-b border-gray-100 px-3 py-2 last:border-0 hover:bg-gray-50 dark:border-gray-800 dark:hover:bg-gray-800"
          [class.bg-blue-50]="!notification.isRead"
          [class.dark:bg-gray-800]="!notification.isRead"
          (click)="open(notification)"
        >
          <div class="text-sm font-medium">{{ notification.title }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">{{ notification.body }}</div>
          <div class="mt-1 text-xs text-gray-400">{{ notification.createdAtUtc | relativeTime }}</div>
        </div>
      } @empty {
        <div class="px-3 py-8 text-center text-sm text-gray-500">{{ 'shared.notifications.empty' | translate }}</div>
      }
    </div>
  </div>
</p-popover>
